<div *ngIf="!isHidden()" class="list-group list-group-flush pb-1">
    <div *ngIf="displayActions && actions" class="d-flex pb-2 pe-2">
        <div class="btn-group ms-auto" [sq-action-buttons]="{items: actions, size: 'sm'}">
        </div>
    </div>

    <div *ngIf="searchItems.selected" class="position-relative" [formGroup]="myGroup">
        <div class="p-1">
            <input class="form-control" sqAutofocus formControlName="searchQuery"
                [placeholder]="'msg#facet.searchPlaceholder' | sqMessage">
        </div>
        <sq-loading-bar [active]="searchActive"></sq-loading-bar>
    </div>

    <!-- filtered items -->

    <div *ngFor="let item of filtered"
        class="d-flex flex-row list-group-item list-group-item-action text-truncate sq-filtered"
        [ngClass]="{'sq-excluded': item.$excluded}" [title]="'msg#facet.selectedValue' | sqMessage"
        (click)="filterItem(item, $event)">

        <input type="checkbox" class="form-check-input me-2" [checked]="true" disabled *ngIf="showCheckbox">

        <!-- ### space between checkbox and label and wrapping the text -->
        <a href="#" class="text-truncate me-auto align-list">{{item | sqValue:item.$column}}</a>

        <span *ngIf="showCount && item.count" class="ms-2 text-muted small">{{item.count | sqNumber}}</span>
    </div>

    <!-- hidden selected items -->
    <div *ngFor="let item of hiddenSelected" class="d-flex flex-row list-group-item text-truncate sq-selected"
        [title]="'msg#facet.itemUnselect' | sqMessage" (click)="selectItem(item, $event)">

        <input type="checkbox" class="form-check-input me-2" [checked]="true" *ngIf="showCheckbox">
        <!-- ### space between checkbox and label and wrapping the text -->
        <a href="#" (click)="filterItem(item, $event)"
            [title]="'msg#facet.filterItem' | sqMessage:{'terme':(item | sqValue:item.$column)}"
            class="text-truncate me-auto align-list">{{item | sqValue:item.$column}}</a>

        <span *ngIf="showCount && item.count" class="ms-2 text-muted small">{{item.count | sqNumber}}</span>
    </div>

    <!--- suggestions items -->
    <div *ngFor="let suggest of suggestions$ | async"
        class="d-flex flex-row list-group-item list-group-item-action text-truncate"
        [ngClass]="{'sq-selected': suggest.$selected}"
        [title]="(suggest.$selected? 'msg#facet.itemUnselect' : 'msg#facet.itemSelect') | sqMessage"
        (click)="selectItem(suggest, $event)">

        <input type="checkbox" class="form-check-input me-2" [checked]="suggest.$selected"
            (change)="selectItem(suggest,$event)" (click)="$event.stopPropagation()" *ngIf="showCheckbox">

        <!-- <input type="checkbox" class="form-check-input me-2" [checked]="suggest.checked"
            (change)="selectItem(suggest,$event)" (click)="$event.stopPropagation()" *ngIf="showCheckbox && hideCard"> -->

        <!-- ### space between checkbox and label and wrapping the text -->
        <a href="#" (click)="filterItem(suggest, $event)" role="button"
            title="{{ 'msg#facet.filterItem' | sqMessage:{'terme':(suggest | sqValue:suggest.$column)} }}"
            class="text-truncate me-auto align-list">{{suggest | sqValue:suggest.$column}}</a>

        <span *ngIf="showCount && suggest.count" class="ms-2 text-muted small" style="z-index: 1;">{{suggest.count |
            sqNumber}}</span>

    </div>
    <span *ngIf="noResults" class="d-block text-center text-muted small py-1"><i>{{'msg#facet.searchNoResult' |
            sqMessage}}</i></span>

    <div *ngIf="!hasSuggestions()" class="facet-results-scrollable">
        <!--- aggregation items without filtered -->
        <div *ngFor="let item of items$ | async" class="position-relative list-group-item list-group-item-action"
            [ngClass]="{'sq-selected': item.$selected}"
            [title]="(item.$selected? 'msg#facet.itemUnselect' : 'msg#facet.itemSelect') | sqMessage"
            (click)="selectItem(item, $event)">

            <div *ngIf="showProgressBar && resultsLength > 1" class="position-absolute progress-bar progress-color"
                [style.--count]="getPercent(item.count)"></div>
            <div class="d-flex justify-content-between">

                <!-- ### using checked property instead of selected property hence hiding this checkbox -->
                <input type="checkbox" class="form-check-input me-2" [checked]="item.$selected"
                    (change)="selectItem(item,$event)" (click)="$event.stopPropagation()"
                    *ngIf="showCheckbox && !hideCard">

                <!-- ### using checked property hence showing this checkbox -->
                <input type="checkbox" class="form-check-input me-2" [checked]="item.checked"
                    (change)="selectItem(item,$event)" (click)="$event.stopPropagation()"
                    *ngIf="showCheckbox && hideCard">

                <!-- ### space between checkbox and label and wrapping the text -->
                <a href="#" (click)="filterItem(item, $event)" style="z-index: 1;"
                    [ngClass]="{'align-options': alignOptions == true}"
                    [title]="'msg#facet.filterItem' | sqMessage:{'terme':(item | sqValue:item.$column)}"
                    class="text-truncate me-auto align-list">{{item | sqValue:item.$column}}</a>

                <span *ngIf="showCount && item.count" class="ms-2 text-muted small" style="z-index: 1;">{{item.count |
                    sqNumber}}</span>
            </div>
        </div>

        <a *ngIf="hasMore" class="d-block border-0 text-center" (click)="loadMore($event)" href="#">
            <span *ngIf="loadingMore" class="fas fa-sync fa-fw fa-spin"></span>
            <small *ngIf="!loadingMore">{{'msg#facet.loadMore' | sqMessage}}</small>
        </a>
    </div>

</div>